// removed by extract-text-webpack-plugin
module.exports = {"vadpLogin":"vadpLogin___1JPuh","container":"container___2x1ih","title":"title___nBF0q","autofill-fix":"autofill-fix___2LOJY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForDark/index.less
// module id = 315
// module chunks = 0